import React, { useContext } from 'react';

export const SkyPlayerContext = React.createContext({});

export const useSkyPlayerContext = (): SkyPlayerContextValue => useContext(SkyPlayerContext);

export interface SkyPlayerContextValue {
  skyPlayersManager?: {
    initPlayer: (htmlId: string | number, config: any) => void;
  }
}